require('../../modules/es.typed-array.float32-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Float32Array;
